import { UpdateResolver } from "@urql/exchange-graphcache";
import { Entity, GetEntitiesListDocument } from "generated/graphql";

export const entityUpdates: {
    [fieldName: string]: UpdateResolver;
} = {
    // Whenever an entity is added, it updates the local cache
    // adding it to the list of entities
    // The key needs to be the actual mutation name
    // Additionally, in order for this to work on the component side
    // it needs to have policy cache-and-network, not network-only
    // for components that are reading data that could be manipulated
    addEntity: (result, args, cache, info) => {
        const addEntity = result.addEntity;
        let appId: string;
        let displayName: string;
        let entityId: string;

        if (typeof addEntity === "object" && !Array.isArray(addEntity)) {
            appId = addEntity.appId;
            displayName = addEntity.displayName;
            entityId = addEntity.entityId;
        }
        cache.updateQuery(
            {
                // The query that is typically called to get the data
                // so that the cache can be updated and the modified
                // data is returned
                query: GetEntitiesListDocument,
                variables: { appId }
            },
            data => {
                if (typeof data.app === "object" && !Array.isArray(data.app)) {
                    if (
                        typeof data.app.entities === "object" &&
                        !Array.isArray(data.app.entities)
                    ) {
                        data.app.entities.entities.push({
                            __typename: "GetEntitiesListEntity",
                            displayName,
                            entityId
                        });
                    }
                }

                return data;
            }
        );
    },
    deleteEntity: (result, args, cache, info) => {
        let appId: string;
        let entityId: string;

        if (typeof args === "object") {
            appId = args.appId as string;
            entityId = args.entityId as string;
        }
        cache.updateQuery(
            {
                query: GetEntitiesListDocument,
                variables: { appId }
            },
            data => {
                if (typeof data.app === "object" && !Array.isArray(data.app)) {
                    if (
                        typeof data.app.entities === "object" &&
                        !Array.isArray(data.app.entities)
                    ) {
                        const indexToDelete = data.app.entities.entities.findIndex(
                            (entity: Entity) => entity.entityId === entityId
                        );

                        if (indexToDelete > -1) {
                            data.app.entities.entities.splice(indexToDelete, 1);
                        }
                    }
                }

                return data;
            }
        );
    }
}